<template>
    <div id="form" :class="['flex flex-col justify-center form-container', !isMobile ? 'px-4' : 'content-box']">
        <div class="title-form mb-4 mt-4 flex justify-center container mx-auto">
            <span>
                Faça agora uma
                <b>
                    <u>Cotação!</u>
                </b>
            </span>
        </div>
        <div class="flex justify-center container mx-auto">
            <eg-input
                id="name"
                :rules="textRules"
                @valid="textRules.valid = $event"
                :valid="valid"
                style="width: 55%"
                class="mr-2"
                placeholder-text="Nome"
                :value="form.name"
                v-model="form.name"
            />
            <eg-input
                :mask="['+55 (##) ####-####', '+55 (##) #####-####']"
                style="width: 45%"
                placeholder-text="Telefone"
                :value="form.tel"
                v-model="form.tel"
                :rules="telRules"
                @valid="telRules.valid = $event"
                @onblur="captureLead"
                :valid="valid"
            />
        </div>
        <div class="flex justify-center container mx-auto mt-2">
            <eg-input
                style="width: 100%"
                placeholder-text="Email"
                :value="form.email"
                v-model="form.email"
                :rules="emailRules"
                @valid="emailRules.valid = $event"
                :valid="valid"
            />
        </div>
        <div class="flex justify-center container mx-auto mt-2">
            <eg-textarea
                :value="form.obs"
                v-model="form.obs"
                :rules="obsRules"
                @valid="obsRules.valid = $event"
                :valid="valid"
                height="80px"
                style="width: 100%"
                placeholder-text="Escreva uma observação..."
            />
        </div>
        <eg-button
            class="container mx-auto flex justify-center mb-4"
            variant="eg-yellow"
            size="large"
            @click="validateFormNotification"
        >
            <b class="text-btn">
                Solicite um orçamento
                <span class="material-icons-outlined">keyboard_double_arrow_right</span>
            </b>
        </eg-button>
    </div>
</template>

<script>
import { computed, reactive, toRefs } from '@vue/composition-api';
import { showToast } from '@/composibles/notification';
import { KEYS } from '@/utils/constants';
import { adwordNotification } from '@/services/api';
import lodash from 'lodash';

export default {
    props: {
        isMobile: [Boolean, Object],
        slugInfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    setup(props, { root }) {
        const self = reactive({
            form: {
                name: '',
                tel: '',
                email: '',
                obs: ''
            },
            formTemp: { name: '', tel: '', email: '', obs: '' },
            sendForm: false
        });

        const validations = reactive({
            textRules: {
                type: 'text',
                name: 'Nome',
                required: true,
                valid: false
            },
            telRules: {
                type: 'text',
                name: 'Telefone',
                required: true,
                valid: false
            },
            emailRules: {
                type: 'email',
                name: 'Telefone',
                required: true,
                valid: false
            },
            obsRules: {
                type: 'text',
                name: 'Observação',
                required: true,
                valid: false
            },
            valid: false
        });

        const validateForm = computed(() => {
            return (
                validations.textRules.valid &&
                validations.telRules.valid &&
                validations.emailRules.valid &&
                validations.obsRules.valid
            );
        });

        const getGoogleAnalyticsClientId = () => {
            let cookie = root.$cookies.get(KEYS.GOOGLE_ANALYTICS);
            if (cookie) {
                cookie = cookie.split('.');
                return cookie[2] + '.' + cookie[3];
            }
            return '';
        };

        const getGoogleAdwordsParameters = () => {
            const googleClickId = root.$route.query['gclid'];
            const googleClientId = getGoogleAnalyticsClientId();
            const utmCampaign = root.$route.query['utm_campaign'];
            const utmContent = root.$route.query['utm_content'];
            const utmMedium = root.$route.query['utm_medium'];
            const utmSource = root.$route.query['utm_source'];
            const utmTerm = root.$route.query['utm_term'];
            const utmAdFormat = root.$route.query['utm_ad_format'];

            return {
                googleClickId: googleClickId,
                googleClientId: googleClientId,
                utmAdFormat: utmAdFormat,
                utmCampaign: utmCampaign,
                utmContent: utmContent,
                utmMedium: utmMedium,
                utmSource: utmSource,
                utmTerm: utmTerm
            };
        };

        const makePostData = async () => {
            let data = {
                contractorEmail: self.form.email,
                phone: self.form.tel,
                tradingName: self.form.name,
                observations: self.form.obs
            };
            data = { ...data, ...getGoogleAdwordsParameters() };
            return data;
        };

        const checkNotificationValidation = () => {
            return validations.telRules.valid || validations.emailRules.valid;
        };

        const validateNotification = () => {
            if (checkNotificationValidation()) {
                if (!lodash.isEqual(self.formTemp, self.form)) {
                    self.formTemp = lodash.cloneDeep(self.form);
                    sendNotification();
                }
            }
        };

        const sendNotification = async () => {
            root.$gtag.event('Lead Qualificado', {
                // eslint-disable-next-line camelcase
                event_category: 'Contratante'
            });
            let data = await makePostData();
            await adwordNotification(data);
            // self.sendForm = true;
        };

        const captureLead = async () => {
            if (self.form.tel.length) {
                let data = await makePostData();
                await adwordNotification(data);
                // self.sendForm = true;
                root.$gtag.event('Lead', {
                    // eslint-disable-next-line camelcase
                    event_category: 'Contratante'
                });
                root.analytics.fbq.event('PageView', {
                    track: 'Lead'
                });
            }
        };

        const prepareQueryByForm = () => {
            self.form.tel = self.form.tel.slice(4, self.form.tel.length)
            let queries = '';
            let i = 0;
            for (let prop in self.form) {
                if (prop != 'obs') {
                    if (i === 0) queries += `?${prop}=${self.form[prop]}`;
                    if (i > 0) queries += `&${prop}=${self.form[prop]}`;
                }
                i++;
            }
            return queries;
        };

        const redirectWithParamsForm = () => {
            const queries = prepareQueryByForm();
            window.location =
                process.env.VUE_APP_DOMAIN_BASE_URL + '/nova-cotacao' + queries + '&servico=' + props.slugInfo.tagName;
        };

        const validateFormNotification = async () => {
            validations.valid = !validations.valid;
            await setTimeout(async () => {
                if (validateForm.value) {
                    try {
                        await sendNotification();
                        redirectWithParamsForm();
                        return true;
                    } catch (error) {
                        console.log(error);
                        showToast({
                            title: 'Erro ao enviar a notificação',
                            icon: 'error',
                            position: 'top'
                        });
                    }
                } else {
                    showToast({
                        title: 'Preencha os campos obrigatórios',
                        icon: 'error',
                        position: 'top'
                    });
                }
            }, 500);
        };

        return {
            ...toRefs(validations),
            ...toRefs(self),
            validateFormNotification,
            sendNotification,
            validateForm,
            validateNotification,
            captureLead
        };
    }
};
</script>

<style lang="scss" scoped>
.content-box {
    @apply container mx-auto px-4;
}
.form-container {
    width: 450px;
    height: 319px;
    left: 968px;
    top: 94px;
    border-radius: 5px;
    background: #0e53a5;
    @media screen and (max-width: 767px) {
        border-radius: 0px;
    }
}
.text-btn {
    @apply font-bold;
    text-transform: uppercase;
    display: flex;
    font-size: 16px;
    @media screen and (max-width: 330px) {
        top: 5px;
        font-size: 11px !important;
    }
    .material-icons-outlined {
        @media screen and (max-width: 1024px) {
            top: 6px;
        }
        @media screen and (max-width: 330px) {
            top: 5px;
            font-size: 13px !important;
        }
    }
}

.title-form {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    color: #ffffff;
}
@media screen and (max-width: 992px) {
    .form-container {
        width: 100%;
        height: auto !important;
    }
}
</style>
